// Prices come from Shopify's native parent variants; regular values use the live components.
function getLumbarOfferState(variants, selectedId, offer, values, secondColour) {
  const current = variants.find(variant => String(variant.id) === String(selectedId));
  if (!current) return null;
  const base = variants.find(variant => variant.option1 === current.option1 && variant.option2 === 'Single');
  const variantOffer = offer === 'Double Support Bundle' && secondColour && secondColour !== current.option1
    ? `Double Support Bundle - ${secondColour} second`
    : offer;
  const variant = variants.find(variant => variant.option1 === current.option1 && variant.option2 === variantOffer);
  if (!base || !variant) return null;
  const count = offer === 'Double Support Bundle' ? 2 : 1;
  const extras = offer === 'Ultimate Comfort Bundle' ? values.cushionRegular + values.ballRegular : 0;
  const regular = Math.max(base.price, base.compare_at_price || 0) * count + extras;
  return { variant, base, price: variant.price, regular, savings: Math.max(0, regular - variant.price), count };
}
if (!customElements.get('lumbar-product')) {
  customElements.define('lumbar-product', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      // Animate the image itself so gallery slide/swipe transforms stay independent.
      const entranceImage = this.querySelector('.lr-slide:not([hidden]) img');
      if (entranceImage && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
        const enter = () => {
          if (!entranceImage.isConnected || entranceImage.closest('.lr-slide').hidden) return;
          entranceImage.animate(
            [{ transform: 'scale(1.045)' }, { transform: 'scale(1)' }],
            { duration: 1100, easing: 'cubic-bezier(.18,.65,.3,1)' }
          );
        };
        if (entranceImage.complete && entranceImage.naturalWidth) enter();
        else entranceImage.addEventListener('load', enter, { once: true });
      }
      this.querySelector('[data-review-link]')?.addEventListener('click', event => {
        const target = this.querySelector('[data-final-reviews]');
        if (!target) return;
        event.preventDefault();
        target.focus({ preventScroll: true });
        target.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
        history.replaceState({}, '', `#${target.id}`);
      });
      const gallery = this.querySelector('.lr-review-cards');
      const track = this.querySelector('.lr-review-track');
      const pause = this.querySelector('[data-review-pause]');
      if (gallery?.dataset.autoScroll === 'true' && track?.children.length > 1) {
        const originalCards=Array.from(track.children);
        const cycleWidth=originalCards.reduce((sum,card)=>sum+card.getBoundingClientRect().width,0)+parseFloat(getComputedStyle(track).gap)*originalCards.length;
        const copies=Math.max(1,Math.ceil((screen.width||innerWidth)/cycleWidth));
        for(let i=1;i<copies;i++)originalCards.forEach(card=>{const clone=card.cloneNode(true);clone.setAttribute('aria-hidden','true');clone.setAttribute('inert','');clone.removeAttribute('data-shopify-editor-block');track.appendChild(clone);});
        Array.from(track.children).forEach(card => {
          const clone = card.cloneNode(true);
          clone.classList.add('lr-review-clone');
          clone.setAttribute('aria-hidden', 'true');
          clone.setAttribute('inert', '');
          clone.removeAttribute('data-shopify-editor-block');
          track.appendChild(clone);
        });
        gallery.classList.add('lr-moving');
        if (gallery.closest('.lrs-photo-strip')) {
          gallery.classList.add('lr-infinite');
          let offset = 0, previous = 0, drag = null;
          const reduced = matchMedia('(prefers-reduced-motion: reduce)');
          const span = () => track.children[originalCards.length].offsetLeft - track.children[0].offsetLeft;
          const render = () => {
            const width = span();
            if (width > 0) offset = ((offset % width) + width) % width;
            track.style.transform = `translateX(${-offset}px)`;
          };
          const tick = time => {
            if (!this.isConnected) return;
            if (previous && !reduced.matches && !gallery.classList.contains('lr-paused')) offset += Math.min(time - previous, 50) * span() / 90000;
            previous = time;
            render();
            this.railFrame = requestAnimationFrame(tick);
          };
          this.railFrame = requestAnimationFrame(tick);
          gallery.addEventListener('dragstart', e => e.preventDefault());
          gallery.addEventListener('pointerdown', e => {
            if (e.button !== 0) return;
            drag = { id: e.pointerId, x: e.clientX };
            gallery.setPointerCapture(e.pointerId);
          });
          gallery.addEventListener('pointermove', e => {
            if (!drag || drag.id !== e.pointerId) return;
            offset += drag.x - e.clientX;
            drag.x = e.clientX;
            render();
          });
          const end = () => { drag = null; };
          gallery.addEventListener('pointerup', end);
          gallery.addEventListener('pointercancel', end);
          gallery.addEventListener('lostpointercapture', end);
          gallery.addEventListener('wheel', e => {
            if (Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return;
            e.preventDefault(); offset += e.deltaX; render();
          }, { passive: false });
        }
        if (pause) pause.hidden = false;
        pause?.addEventListener('click', () => {
          const paused = gallery.classList.toggle('lr-paused');
          pause.setAttribute('aria-pressed', String(paused));
          pause.textContent = paused ? 'Resume photo movement' : 'Pause photo movement';
        });
      }
      const variants = JSON.parse(this.querySelector('[data-variants]').textContent);
      const bundleValues = JSON.parse(this.querySelector('[data-bundle-values]').textContent);
      const cartEventsPromise = import('@shopify/events');
      const form = this.querySelector('form');
      const stickyBar = this.querySelector('.lr-mobile');
      const mainButton = form.querySelector('.lr-cta');
      if (stickyBar && mainButton) {
        const syncSticky = () => {
          this.stickyFrame = null;
          stickyBar.hidden = mainButton.getBoundingClientRect().bottom > 0;
        };
        this.stickyObserver = new IntersectionObserver(syncSticky, { threshold: 0 });
        this.stickyObserver.observe(mainButton);
        this.stickyScroll = () => {
          if (!this.stickyFrame) this.stickyFrame = requestAnimationFrame(syncSticky);
        };
        document.addEventListener('scroll', this.stickyScroll, { capture: true, passive: true });
        syncSticky();
      }
      const variantInput = form.elements.id;
      const money = value => new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: this.dataset.currency }).format(value / 100);
      const showMedia = id => {
        if (!this.querySelector(`[data-media="${id}"]`)) return;
        this.querySelectorAll('[data-media]').forEach(el => { el.hidden = el.dataset.media !== String(id); if (el.hidden) el.querySelectorAll('video').forEach(video => video.pause()); });
        this.querySelectorAll('[data-thumb]').forEach(el => el.setAttribute('aria-pressed', String(el.dataset.thumb === String(id))));
      };
      const showOfferMedia = offer => {
        const target = offer === 'Single'
          ? this.querySelector('.lr-stage [data-media="custom"]') || this.querySelector('.lr-stage [data-media]')
          : this.querySelector(`.lr-stage [data-offer-media="${offer === 'Ultimate Comfort Bundle' ? 'ultimate' : 'double'}"]`);
        if (target) showMedia(target.dataset.media);
      };
      const showColourMedia = colour => {
        const singleVariant = variants.find(variant => variant.option1 === colour && variant.option2 === 'Single');
        const button = singleVariant && this.querySelector(`[data-colour-variant="${singleVariant.id}"]`);
        if (button?.dataset.colourMedia) showMedia(button.dataset.colourMedia);
      };
      this.querySelectorAll('[data-thumb]').forEach(button => button.addEventListener('click', () => { if (!settling) showMedia(button.dataset.thumb); }));
      const stage = this.querySelector('.lr-stage');
      const slides = Array.from(stage.querySelectorAll('[data-media]'));
      let settling = false;
      const stepMedia = (direction, offset = 0, commit = true) => {
        if (settling) return;
        const current = slides.findIndex(slide => !slide.hidden);
        if (slides.length < 2) return;
        const next = slides[(current + direction + slides.length) % slides.length];
        const active = slides[current];
        const width = stage.clientWidth;
        const adjacentOffset = offset + direction * width;
        next.classList.add('lr-drag-preview');
        next.style.transform = `translateX(${adjacentOffset}px)`;
        active.style.transform = `translateX(${offset}px)`;
        settling = true;
        const duration = matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 360;
        const options = { duration, easing: 'cubic-bezier(.22,.68,.25,1)', fill: 'forwards' };
        const animations = [
          active.animate([{transform:`translateX(${offset}px)`},{transform:`translateX(${commit ? -direction * width : 0}px)`}], options),
          next.animate([{transform:`translateX(${adjacentOffset}px)`},{transform:`translateX(${commit ? 0 : direction * width}px)`}], options)
        ];
        Promise.all(animations.map(animation => animation.finished)).then(() => {
          if (commit) showMedia(next.dataset.media);
          clearPreview();
          animations.forEach(animation => animation.cancel());
          settling = false;
          const thumb = this.querySelector(`[data-thumb="${(commit ? next : active).dataset.media}"]`);
          if (thumb) { const strip = thumb.parentElement; strip.scrollTo({left:thumb.offsetLeft - strip.offsetLeft - strip.clientWidth / 2 + thumb.clientWidth / 2,behavior:'smooth'}); }
        });
      };
      this.querySelector('[data-gallery-back]').addEventListener('click', () => stepMedia(-1));
      this.querySelector('[data-gallery-forward]').addEventListener('click', () => stepMedia(1));
      stage.tabIndex = 0;
      stage.setAttribute('role', 'region');
      stage.setAttribute('aria-label', 'Product images. Swipe or use left and right arrow keys to browse.');
      stage.addEventListener('keydown', event => {
        if (event.target !== stage || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault(); stepMedia(event.key === 'ArrowRight' ? 1 : -1);
      });
      let drag = null;
      const clearPreview = () => slides.forEach(slide => { slide.style.transform = ''; slide.classList.remove('lr-drag-preview'); });
      stage.addEventListener('pointermove', event => {
        if (!drag || drag.id !== event.pointerId) return;
        const dx = event.clientX - drag.x;
        const current = slides.findIndex(slide => !slide.hidden);
        if (current < 0 || slides.length < 2) return;
        clearPreview();
        const width = stage.clientWidth;
        const offset = Math.max(-width, Math.min(width, dx));
        slides[current].style.transform = `translateX(${offset}px)`;
        const adjacent = slides[(current + (dx < 0 ? 1 : -1) + slides.length) % slides.length];
        adjacent.classList.add('lr-drag-preview');
        adjacent.style.transform = `translateX(${offset + (dx < 0 ? width : -width)}px)`;
      });
      stage.addEventListener('dragstart', event => { if (event.target.tagName === 'IMG') event.preventDefault(); });
      stage.addEventListener('pointerdown', event => {
        if (settling || !event.isPrimary || event.button !== 0 || event.target.closest('video, iframe, model-viewer, button, a')) return;
        drag = { id: event.pointerId, x: event.clientX, y: event.clientY };
        stage.setPointerCapture(event.pointerId);
        stage.classList.add('lr-dragging');
      });
      const finishDrag = event => {
        if (!drag || drag.id !== event.pointerId) return;
        const dx = event.clientX - drag.x, dy = event.clientY - drag.y;
        drag = null; stage.classList.remove('lr-dragging');
        if (stage.hasPointerCapture(event.pointerId)) stage.releasePointerCapture(event.pointerId);
        const commit = event.type === 'pointerup' && Math.abs(dx) >= 40 && Math.abs(dx) > Math.abs(dy) * 1.25;
        stepMedia(dx < 0 ? 1 : -1, Math.max(-stage.clientWidth, Math.min(stage.clientWidth, dx)), commit);
      };
      stage.addEventListener('pointerup', finishDrag);
      stage.addEventListener('pointercancel', finishDrag);
      stage.addEventListener('lostpointercapture', () => { if (drag) { clearPreview(); drag = null; stage.classList.remove('lr-dragging'); } });

      const thumbs = this.querySelector('.lr-thumbnails');
      this.querySelector('[data-prev]').addEventListener('click', () => thumbs.scrollBy({ left: -240, behavior: 'smooth' }));
      this.querySelector('[data-next]').addEventListener('click', () => thumbs.scrollBy({ left: 240, behavior: 'smooth' }));
      const selectedOffer = () => form.querySelector('[name="offer"]:checked')?.value || 'Single';
      const secondColour = () => form.querySelector('[name="second_colour"]:checked')?.value;
      const currentState = () => getLumbarOfferState(variants, variantInput.value, selectedOffer(), bundleValues, secondColour());
      const pageScroller = document.querySelector('.page-wrapper');
      if (pageScroller && getComputedStyle(pageScroller).overflowY !== 'visible') {
        window.addEventListener('scroll', () => {
          if (window.scrollY) window.scrollTo(0, 0);
        }, { passive: true });
      }
      let offerPointerScroll = null;
      this.querySelector('.lr-offers')?.addEventListener('pointerdown', () => {
        offerPointerScroll = { page: pageScroller?.scrollTop ?? 0, window: window.scrollY };
      }, { passive: true });
      const update = () => {
        const state = currentState();
        if (!state) return;
        const { variant: v, base, price, regular, savings } = state;
        variantInput.value = String(v.id);
        const isDouble = selectedOffer() === 'Double Support Bundle';
        this.querySelector('[data-second-colour]').hidden = !isDouble;
        this.querySelector('.lr-colours legend').textContent = isDouble ? 'First LumbarRelief™ colour' : 'Choose Your Colour';
        this.querySelectorAll('[data-colour-variant]').forEach(button => {
          button.setAttribute('aria-pressed', String(button.dataset.colourVariant === String(base.id)));
          button.disabled = Boolean(this.busy);
        });
        this.querySelectorAll('.lr-offer').forEach(card => {
          const radio = card.querySelector('[name="offer"]');
          const option = getLumbarOfferState(variants, v.id, radio.value, bundleValues, secondColour());
          radio.disabled = Boolean(this.busy) || !option?.variant.available;
          if (!option) return;
          card.querySelector('[data-bundle-price]').textContent = money(option.price);
          card.querySelector('[data-bundle-compare]').textContent = money(option.regular);
          card.querySelector('[data-bundle-compare]').hidden = !option.savings;
          card.querySelector('[data-bundle-saving]').textContent = `${Math.round(option.savings / option.regular * 20) * 5}% OFF`;
          card.querySelector('[data-bundle-saving]').hidden = !option.savings;
        });
        this.querySelector('[data-price]').textContent = money(price);
        const compare = this.querySelector('[data-compare]'), save = this.querySelector('[data-save]');
        compare.hidden = save.hidden = !savings;
        compare.textContent = money(regular);
        save.textContent = `SAVE ${money(Math.floor(savings / 100) * 100).replace(/([.,]00)(?=\D*$)/, '')}`;
        this.querySelectorAll('[data-mobile-price]').forEach(el => el.textContent = money(price));
        this.querySelectorAll('[data-mobile-compare]').forEach(el => { el.textContent = money(regular); el.hidden = !savings; });
        this.querySelectorAll('[data-mobile-save]').forEach(el => { el.hidden = !savings; el.textContent = `SAVE ${money(Math.floor(savings / 100) * 100).replace(/([.,]00)(?=\D*$)/, '')}`; });
        if (!this.busy) this.querySelectorAll('.lr-cta').forEach(el => {
          el.disabled = !v.available;
          el.classList.remove('lr-cta--loading');
          el.textContent = v.available ? 'CLAIM OFFER' : 'SOLD OUT';
        });
      };
      form.addEventListener('change', event => {
        update();
        const state = currentState();
        if (!state) return;
        if (event.target.matches('[name="offer"]')) showOfferMedia(selectedOffer());
        if (event.target.matches('[name="second_colour"]')) showColourMedia(secondColour());
        if (event.target.matches('[name="offer"], [name="second_colour"]') && offerPointerScroll) {
          const position = offerPointerScroll;
          offerPointerScroll = null;
          requestAnimationFrame(() => {
            if (pageScroller && pageScroller.scrollTop !== position.page) {
              const behavior = pageScroller.style.scrollBehavior;
              pageScroller.style.scrollBehavior = 'auto';
              pageScroller.scrollTop = position.page;
              pageScroller.style.scrollBehavior = behavior;
            }
            if (window.scrollY !== position.window) {
              const root = document.documentElement;
              const behavior = root.style.scrollBehavior;
              root.style.scrollBehavior = 'auto';
              window.scrollTo(0, position.window);
              root.style.scrollBehavior = behavior;
            }
          });
        }
      });
      this.querySelectorAll('[data-colour-variant]').forEach(button=>button.addEventListener('click',()=>{variantInput.value=button.dataset.colourVariant;variantInput.dispatchEvent(new Event('change',{bubbles:true}));if(button.dataset.colourMedia)showMedia(button.dataset.colourMedia);}));
      form.addEventListener('submit', async event => {
        event.preventDefault();
        if (this.busy) return;
        this.busy = true;
        update();
        const error = this.querySelector('.lr-error'); error.hidden = true;
        this.querySelectorAll('.lr-cta').forEach(el => { el.disabled = true; el.classList.add('lr-cta--loading'); el.innerHTML = '<span class="lr-cta-spinner" aria-hidden="true"></span><span>Adding to cart…</span>'; });
        try {
          const payload = { items: [{ id: variantInput.value, quantity: Number(form.elements.quantity?.value || 1) }] };
          payload.sections = Array.from(document.querySelectorAll('cart-items-component')).map(el => el.dataset.sectionId).filter(Boolean).join(',');
          payload.sections_url = location.pathname;
          const response = await fetch(this.dataset.add, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(payload) });
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || result.message || 'Unable to add this item. Please try again.');
          await customElements.whenDefined('theme-drawer');
          const drawer = document.querySelector('#cart-drawer');
          drawer?.setAttribute('data-lr-cart-loading', '');
          drawer?.open();
          const cartResponse = await fetch(`${this.dataset.cart}.js`, { headers: { Accept: 'application/json' } });
          if (!cartResponse.ok) throw new Error('Item added. Please open the cart to view it.');
          const cart = await cartResponse.json();
          const { CartLinesUpdateEvent } = await cartEventsPromise;
          const deferred = CartLinesUpdateEvent.createPromise();
          this.dispatchEvent(new CartLinesUpdateEvent({ action: 'add', context: 'product', lines: [{ merchandiseId: variantInput.value, quantity: payload.items[0].quantity }], promise: deferred.promise }));
          deferred.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { items: cart.items, source: 'product-form-component', sourceId: this.id, itemCount: payload.items[0].quantity, sections: result.sections, didError: false } });
          requestAnimationFrame(() => requestAnimationFrame(() => drawer?.removeAttribute('data-lr-cart-loading')));
          this.busy = false; update();
        } catch (err) { document.querySelector('#cart-drawer')?.removeAttribute('data-lr-cart-loading'); error.textContent = err.message; error.hidden = false; error.scrollIntoView({ block: 'center', behavior: 'smooth' }); this.busy = false; update(); }
      });
      update();
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.railFrame);
      this.stickyObserver?.disconnect();
      document.removeEventListener('scroll', this.stickyScroll, true);
      cancelAnimationFrame(this.stickyFrame);
      this.ready = false;
    }
  });
}
